import { push } from 'react-router-redux';
import moment from 'moment';

import { unselectDevice } from './map';
import { PROCESSING_SELECTION } from './map';

export const FETCH_EVENTS = 'FETCH_EVENTS';
export const POST_EVENT = 'POST_EVENT';
export const TOGGLE_EVENT_FORM = 'TOGGLE_EVENT_FORM';
export const POST_SCHEDULE = 'POST_SCHEDULE';
export const PUT_SCHEDULE = 'PUT_SCHEDULE';
export const ADD_DEVICE_TO_SCHEDULE = 'ADD_DEVICE_TO_SCHEDULE';
export const PUBLISH_EVENT = 'PUBLISH_EVENT';

import {
  getEvents,
  postEvent,
  postSchedule,
  putSchedule,
  postDeviceToSchedule,
  publishEvent,
} from '../api';

export const fetchEvents = (organisationId) => ({
  type: FETCH_EVENTS,
  payload: getEvents(organisationId),
});

export const createEvent = (organisationId, event) => (dispatch, getState) => {
  const selectedDate = getState().ui.dateSelector.date;
  event.event_date = moment(new Date(selectedDate)).format("YYYY-MM-DD");

  return dispatch({
    type: POST_EVENT,
    payload: postEvent(organisationId, event),
  }).then( ({ value }) => dispatch(push(`/organisations/${organisationId}/events/${value.id}/schedules`)));
};

export const createSchedule = (eventId, schedule) => ({
  type: POST_SCHEDULE,
  payload: postSchedule(eventId, schedule),
});

export const updateSchedule = (eventId, schedule) => ({
  type: PUT_SCHEDULE,
  payload: putSchedule(eventId, schedule),
});

export const toggleEventForm = () => ({
  type: TOGGLE_EVENT_FORM,
});

export const addDeviceToSchedule = (eventId, scheduleId, deviceAddress) => ({
  type: ADD_DEVICE_TO_SCHEDULE,
  payload: postDeviceToSchedule(eventId, scheduleId, deviceAddress)
});

export const publish = (organisationId, eventId) => ({
  type: PUBLISH_EVENT,
  payload: publishEvent(organisationId, eventId),
});

// export const addDevicesToSchedule = (organisationId, eventId, scheduleId) => (dispatch, getState) => {
//   const device_ids = getState().ui.map.selected_device_ids;
//   const devices = getState().devices.data;
//
//   return dispatch({
//     type: PROCESSING_SELECTION,
//     payload: Promise.all(
//       device_ids.map(d_id => {
//         const address = devices.find(d => d.id === d_id).uid
//         // CTL is not understanding PATCH method, but it looks like PUT is acting
//         // as patch anyway, so we just send profile_id instead of the whole device model
//         return dispatch(addDeviceToSchedule(eventId, scheduleId, address))
//           .then(value => dispatch(unselectDevice(devices.find(d => d.uid === value.value.device_address).id))) //
//       })
//     )
//   }).then(() => dispatch(fetchEvents(organisationId)))
//     //.catch(err => dispatch(fetchEvents(organisationId)));
// }

export const addDevicesToSchedule = (organisationId, eventId, scheduleId) => (dispatch, getState) => {
  const device_ids = getState().ui.map.selected_device_ids;
  const devices = getState().devices.data;

  return dispatch({
    type: PROCESSING_SELECTION,
    payload: device_ids.map(d_id => {
      const address = devices.find(d => d.id === d_id).uid
      return dispatch(addDeviceToSchedule(eventId, scheduleId, address))
        .then(value => dispatch(unselectDevice(devices.find(d => d.uid === value.value.device_address).id)))
    }).reduce((promiseChain, currentTask) => {
      return promiseChain.then(chainResults =>
        currentTask.then(currentResult =>
            [ ...chainResults, currentResult ]
        )
    );}, Promise.resolve([]))
  }).then(() => dispatch(fetchEvents(organisationId)));
}



// WEBPACK FOOTER //
// ./src/actions/events.js